<script setup>
defineProps({
  text: {
    type: String,
    required: true,
  },
  marginBottom: {
    type: Boolean,
    required: false,
  },
  theme: {
    type: String,
    required: false,
    default: 'primary',
    validator: (value) =>
      ['primary', 'white', 'pink', 'gray', 'outlined'].includes(value),
  },
})
</script>
<template>
  <div
    class="relative mx-[2px] flex-wrap inline-flex items-center justify-center whitespace-nowrap rounded-xl px-3 py-1 font-sans text-[0.65rem] font-bold uppercase"
    :class="[
      {
        'mb-2': marginBottom === true,
      },
      {
        'bg-gray-200 text-gray-800': theme === 'primary',
      },
      {
        'bg-gray-500 text-white': theme === 'gray',
      },
      {
        'bg-white hover:bg-gray-600 hover:text-white': theme === 'white',
      },
      {
        'bg-primary text-white': theme === 'pink',
      },
      {
        'border border-gray-600 bg-gray-100': theme === 'outlined',
      },
    ]"
  >
    {{ text }}
  </div>
</template>
